import { defineStore } from 'pinia';
import {usePage} from "@inertiajs/inertia-vue3";
import * as api from "../services/api";

export const useAppsStore = defineStore('AppsStore', {
    state: () => {
        return {
            all: [],
            categories: [],
            seasons: [], // für den Season-Filter, siehe utils/seasonFilter.mjs
            account_id: null, // für welchen Account `all` geladen ist
            pending: null,
            loading: true,
            open_panels: [],
            show: 'apps', // or coverpages
        };
    },
    getters: {
        currentCategories: (state) => {
            // Show all categories for a Operator
            if (usePage().props.value.auth.user.operator) return state.categories;

            if (state.show === 'coverpages') {
                state.open_panels = [7];
                return state.categories.filter(c => c.id === 7);
            }
            return state.categories.filter(c => c.id !== 7);
        }
    },
    actions: {
        loadApps() {
            /*
             * Die Auswahl hängt am Account: Jeder Kunde sieht zusätzlich die
             * Apps seiner eigenen Seasons. Der Store überlebt einen
             * Seitenwechsel ohne Neuladen. Vorher wurde nur einmal geladen,
             * und wer von der Kampagne eines Kunden zur Kampagne eines
             * anderen wechselte, bekam die Apps des ersten angeboten.
             */
            const account_id = usePage().props.value.account.id;

            if (this.account_id === account_id) {
                if (this.pending) return this.pending;

                // Prevent needless double loading!
                if (this.all.length > 0) {
                    this.loading = false;
                    return Promise.resolve();
                }
            }

            this.$patch({
                all: [],
                categories: [],
                seasons: [],
                account_id,
                loading: true,
            });

            const url = window.route('applications.forStepSelection', {
                account: account_id,
            });

            this.pending = new Promise((resolve, reject) => {
                api.client.get(url)
                    .then(response => {
                        // Inzwischen anderer Account: Antwort verwerfen.
                        if (this.account_id !== account_id) return resolve();

                        this.all = response.data.apps;
                        this.categories = response.data.categories;
                        this.seasons = response.data.seasons ?? [];
                        resolve();
                    })
                    .catch(error => {
                        console.error(error);
                        reject(error.response?.data || error);
                    })
                    .finally(() => {
                        if (this.account_id !== account_id) return;
                        this.loading = false;
                        this.pending = null;
                    });
            });

            return this.pending;
        }
    }
});
